import { Maybe } from 'maybeasy';
import { Link } from '../../../../../../../Resource/Types';
import { T } from '../../../../../../../Translations';
import { observer } from 'mobx-react';

interface Props {
  previewUrl: Maybe<Link>;
}

function UploadSection({ previewUrl }: Props) {
  return previewUrl
    .map((link) => (
      <img
        src={link.href}
        alt="File preview"
        className="object-contain max-w-full max-h-[146px] rounded-md"
      />
    ))
    .getOrElse(() => (
      <label
        htmlFor="upload-button"
        className="py-2.5 px-5 text-sm font-bold bg-white 
              rounded-md border border-teal-600 text-teal-600 cursor-pointer"
        data-intercom-target="upload-organization-logo-button"
      >
        <T kind="Upload Image" />
      </label>
    ));
}

export default observer(UploadSection);
